
export default function useScriptsToRoute(currentRoute: string) {
  let useMgid = true;
  let useGpt = true;
  let useMarfeel = true;
  let useGtm = true;
  let useNavbar = true;
  let useComscore = true;
  let useFullScreen = false;
  let useRun = true;
  let useTeads = false;
  let useCnn = true;
  let specifyId = undefined;

  const autoEditorial = ['veiculos', 'carros', 'mobilidade-urbana', 'veiculos-autonomos'];

  // /carros/hilux-2026-flagra-mostra-mudanca-radical-na-picape-da-toyota/
  const routeParts = currentRoute.split('/').filter(Boolean);
  const category = routeParts[0];
  const isArticleRoute = routeParts.length > 1;
  const isAutoEditorialCategory = autoEditorial.includes(category) && isArticleRoute;

  if (isAutoEditorialCategory) {
    useTeads = true;
  }

  switch (currentRoute) {
      case '/guia-de-compras':
        useMgid = false;
        useGpt = false;
        useMarfeel = false;
        useComscore = false;

        useNavbar = false;
        useFullScreen = true;
        useRun = false;
        useCnn = true;

        specifyId = 'GTM-PT37RWSC';
        break;
      case '/live':
        useMgid = false;
        useGpt = false;
        useMarfeel = false;
        useComscore = false;
        useCnn = false;

        useNavbar = false;
        useFullScreen = true;
        useRun = false;

        specifyId = 'GTM-K9569WH2';
        break;
      case '/oppo':
        useMgid = false;
        useGpt = false;
        useMarfeel = false;
        useComscore = false;
        useCnn = false;
        useNavbar = false;
        useFullScreen = true;
        useRun = false;
        break;
      default:
        break;
    }

  // sobrescreve useCnn se for página de erro
  if (currentRoute === '/404' || currentRoute === '/500') {
    useCnn = false;
  }

  return {
    useMgid: useMgid,
    useGpt: useGpt,
    useMarfeel: useMarfeel,
    useTeads: useTeads,
    useCnn : useCnn,
    useGtm: useGtm,
    specifyId: specifyId,
    useNavbar: useNavbar,
    useComscore: useComscore,
    useRun: useRun,
    useFullScreen: useFullScreen,
  };
}
